import { useEffect, useState } from 'react';
import { useRouter, usePathname } from 'expo-router';
import { useAuth } from '@/services/auth/AuthProvider';
import { useGetUser } from '@/shared/hooks/useGetUser';
import { ROUTES } from '@/shared/constants/routes';
import { IS_WEB } from '../constants/utility';

export function useAuthRouting(): boolean {
  const router = useRouter();
  const pathname = usePathname();
  const { isAuthenticated, auth0User } = useAuth();
  const { user, isLoadingUser } = useGetUser();
  const [isRoutingComplete, setIsRoutingComplete] = useState(false);

  useEffect(() => {
    const handleRouting = async () => {
      if (isLoadingUser) return;
      const userType = auth0User?.user_role;
      const isStylist = userType === 'STYLIST';

      const welcomeSlug = isStylist ? 'stylist' : 'client';

      const onboardingPath = isStylist
        ? ROUTES.ONBOARDING.path
        : ROUTES.CLIENT_ONBOARDING.path;

      if (pathname === ROUTES.CLOSE_SCREEN.path) {
        return;
      }
      if (!isAuthenticated) {
        if (
          pathname !== ROUTES.WELCOME.path &&
          pathname !== ROUTES.WELCOME_INTRO('').path &&
          pathname !== ROUTES.NOT_A_NORMAL_SHOW.path &&
          pathname !== ROUTES.PRIVACY.path &&
          pathname !== ROUTES.TERMS.path &&
          pathname !== ROUTES.FAQ.path &&
          !pathname.includes('/stylist-preview/')
        ) {
          router.replace(ROUTES.WELCOME.path);
        }
      } else if (!user && pathname !== onboardingPath) {
        router.replace(ROUTES.WELCOME_INTRO(welcomeSlug).path);
      } else if (
        user?.stylist &&
        (!user.stylist.bio || !user.stylist.hasCompletedStripeSetup)
      ) {
        // Route to step is handled in the onboarding index
        router.replace(onboardingPath);
      } else {
        // On iOS we need to route them home explicitly
        if (!IS_WEB && pathname === ROUTES.WELCOME.path) {
          router.replace('/');
        }
      }

      setIsRoutingComplete(true);
    };
    handleRouting();
  }, [
    auth0User?.user_role,
    isAuthenticated,
    isLoadingUser,
    pathname,
    router,
    user,
  ]);

  return isRoutingComplete;
}
